module.exports = __webpack_public_path__ + "static/media/2.017872f3.mp4";